import React from "react";
import CheckupPlanFormPage from "../components/checkup-plans/CheckupPlanFormPage";

const CheckupPlanEdit = () => <CheckupPlanFormPage mode="edit" />;

export default CheckupPlanEdit;
